import { useMutation, UseMutationOptions } from 'react-query';
import {
  AdExposureHandleMutationRequestInput,
  HandleAdExposure
} from '@/api/bff_types';
import { useRecoilValue } from 'recoil';
import { authState } from '@/recoil/auth';
import { submitAdExposureLog } from '@/utils/graphqlApis';
import { SEND_AD_BANNER_EXPOSURE_LOG } from '@/hooks/advertisement/queryKeys';

const useSendAdBannerExposureLog = (
  options?: UseMutationOptions<
    HandleAdExposure | undefined,
    Error,
    AdExposureHandleMutationRequestInput
  >
) => {
  const { token } = useRecoilValue(authState);
  return useMutation<
    HandleAdExposure | undefined,
    Error,
    AdExposureHandleMutationRequestInput
  >(
    [SEND_AD_BANNER_EXPOSURE_LOG],
    (variables: AdExposureHandleMutationRequestInput) =>
      submitAdExposureLog(variables, token),
    options
  );
};

export default useSendAdBannerExposureLog;
